import { useContext } from "react";
import { CompanyContext } from "../context";

export const useCompany = () => useContext(CompanyContext);
